export const imageStyles = {
  width: { xs: 11, md: 24 },
  height: { xs: 11, md: 24 },
  mb: { xs: 1, md: 2.25 },
}

export const buttonStyles = {
  backgroundColor: "#FFDAC0 !important",
  opacity: "1 !important",
  fontSize: { xs: 7, md: 14 },
  borderRadius: "4px !important",
}

export const iconStyles = {
  py: { xs: 0.55, md: 1.5 },
  px: { xs: 0.55 },
  backgroundColor: "#FFDEC6",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: 1,
  "& svg": {
    width: { xs: 9, md: 24 },
    height: { xs: 9, md: 24 },
  },
}